/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { PORTAL_WRAPPER_ID } from "utils/constants";

const useBodyScrollByPortalElements = ({
	flag
}) => {
	useEffect(() => {
		const $elements = getElements();
		if (noHiddenElements($elements)) 
			showBodyScroll(false);
		else showBodyScroll(true);
	}, [flag]);
	function getElements() {
		return document.querySelectorAll(`#${PORTAL_WRAPPER_ID} > *`);
	}
	function showBodyScroll(show) {
		document.body.classList[show ? "remove" : "add"]("no-scroll");
	}
	function noHiddenElements($elements) {
		return Array.from($elements).some($element => {
			return !$element.classList.contains("hidden");
		});
	}
}	
	
export default useBodyScrollByPortalElements;